const CARD_BRAND_LABELS: Record<string, string> = {
  visa: "Visa",
  mastercard: "MasterCard",
  amex: "American Express",
  discover: "Discover",
  diners: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
};

export const formatCardBrand = (brand?: string): string => {
  const normalizedBrand = brand?.trim().toLowerCase();
  const cardBrandKey = normalizedBrand?.replace(/[\s_-]+/g, "");

  if (!cardBrandKey) return "Card";

  return (
    CARD_BRAND_LABELS[cardBrandKey] ||
    normalizedBrand!
      .split(/[\s_-]+/)
      .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
      .join(" ")
  );
};
